import React from 'react';
import PropTypes from 'prop-types';
import AlertTrendSparkline from './AlertTrendSparkline';

const TRIGGERED_STROKE = '#dc3545';
const NORMAL_STROKE = '#28a745';

const TrendCell = ({
  samples, isLoading, thresholdValue, isTriggered, isBoolean,
}) => (
  <td className="align-middle">
    <AlertTrendSparkline
      samples={samples}
      isLoading={isLoading}
      thresholdValue={thresholdValue}
      strokeColor={isTriggered ? TRIGGERED_STROKE : NORMAL_STROKE}
      thresholdColor="#000000"
      isBoolean={isBoolean}
    />
  </td>
);

TrendCell.propTypes = {
  samples: PropTypes.arrayOf(PropTypes.shape({
    time: PropTypes.instanceOf(Date),
    value: PropTypes.number,
  })),
  isLoading: PropTypes.bool,
  thresholdValue: PropTypes.number.isRequired,
  isTriggered: PropTypes.bool,
  isBoolean: PropTypes.bool,
};

TrendCell.defaultProps = {
  samples: null,
  isLoading: false,
  isTriggered: false,
  isBoolean: false,
};

export default TrendCell;
